import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { ref } from "vue";
import ReportService from "../../services/ReportService";
import { ElNotification } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'SendConfirmation',
  setup(__props, { expose: __expose }) {

const dialogVisible = ref(false);
const dialogRef = ref(null);
const data = ref(Array<any>());
const email = ref(null);
const isLoading = ref(false);

const show = (item: any) => {
  dialogVisible.value = true;
  data.value = item;
};
const send = async (item: any) => {
  isLoading.value = true;

  try {
    await ReportService.sendAccountReport(data.value.id, {
      email: email.value,
    }).then((res) => {
      ElNotification({
        title: "Success",
        message: "Send successfully",
        type: "success",
      });
      dialogVisible.value = false;
    });
  } catch (error) {
    ElNotification({
      title: "Error",
      message: "Send failed",
      type: "error",
    });
  }
  isLoading.value = false;
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
    title: "Send Report",
    width: "40%",
    class: "min-h-200px",
    ref_key: "dialogRef",
    ref: dialogRef,
    "align-center": "",
    draggable: ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Close ")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: send
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Send ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_input, {
          class: "mb-2 w-300px",
          modelValue: email.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
          placeholder: "Email"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_text, {
            type: "warning",
            class: "mt-4 mx-1",
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Leave email field blank will send the report to the user.")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})